<template>
    <b-card :header="header">
        <div class="mb-3 text-right">
            <b-button
                variant="primary"
                size="sm"
                :title="$t('committees.clickToEdit')"
                @click="onUpdate"
            >
                <i class="fa fa-pencil fa-lg" />
                {{ $t('form.button.updateCommittee') }}
            </b-button>

            <b-button
                variant="danger"
                class="float-right ml-1"
                size="sm"
                :title="$t('committees.clickToDelete')"
                @click="onDelete"
            >
                <i class="fas fa-trash fa-lg" />
                {{ $t('form.button.deleteCommittee') }}
            </b-button>
        </div>

        <b-card class="scroll">
            <b-media v-show="committee.evaluators.length === 0">
                {{ $t('committees.noUser') }}
            </b-media>
            <b-media v-for="(user, index) in committee.evaluators" :key="index">
                <template v-slot:aside>
                    <b-img
                        v-if="user.picture"
                        :src="user.picture"
                        width="42"
                        :alt="user.name"
                        rounded="circle"
                    />
                    <b-img
                        v-else
                        :src="user.picture"
                        blank
                        blank-color="#ccc"
                        width="42"
                        :alt="user.name"
                        rounded="circle"
                    />
                </template>

                <b-row>
                    <b-col lg="10" md="10" xl="10">
                        <h5>{{ user.name }}</h5>
                    </b-col>
                </b-row>

                <h6>
                    {{ user.occupation || $t('committees.noRegistry') }}
                </h6>
            </b-media>
        </b-card>

        <template v-slot:footer>
            <h4>
                <small class="text-muted">
                    {{ $t('committees.form.quantity') }}:
                    {{ committee.evaluators.length }}
                </small>
            </h4>
        </template>
    </b-card>
</template>

<script>
import i18n from '@/i18n'
import api from '@/services/api'
import Swal from 'sweetalert2'
import notification, { success, danger } from '@/lib/notification'

notification.init()

export default {
    name: '',
    props: ['committee', 'header', 'id'],
    methods: {
        onUpdate() {
            return this.$router.push({ path: `edit/${this.id}` })
        },
        onDelete() {
            Swal({
                type: 'warning',
                title: i18n.t('notification.areYouSure'),
                confirmButtonText: i18n.t('notification.yes'),
                cancelButtonText: i18n.t('notification.no'),
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return api
                        .delete(`admin/committees/${this.id}`)
                        .then(() => {
                            success(
                                i18n.t('notification.deletedSuccessfully', {
                                    item: i18n.t('committees.committee'),
                                })
                            )
                            return this.$emit('deleted', this.id)
                        })
                        .catch(error => {
                            danger(error)
                        })
                },
            })
        },
    },
}
</script>

<style scoped>
.scroll {
    max-height: 387px;
    overflow-y: auto;
}
</style>
